<template>
  <div class="row" :class="{ masque: this.display === true }">
    <p class="select_title">{{ this.description }}</p>
    <select
      :class="stylechange"
      v-model="selected"
      required
      @change="change"
      @input="change"
    >
      <option class="option" v-if="placeholder !== ''" :value="null" disabled selected>{{
        this.placeholder
      }}</option>
      <option
        class="option"
        v-for="option in options"
        :value="getLabelValue(option)"
        :key="option.id"
        >{{ getLabel(option) }}</option
      >
    </select>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
    },
    description: {
      type: String,
    },
    label: {
      type: String,
    },
    Api: {
      type: Boolean,
    },
    value: {
      type: [String, Number, Boolean],
    },
    display: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    stylechange:{
      type:String,
      default:'select'
    }
  },
  data() {
    return {
      selected: this.value,
    };
  },
  methods: {
    change() {
      this.$emit("input", this.selected);
      this.$emit("change", this.selected);
    },
    getLabel(option) {
      if (this.Api == true) {
        return option[this.label];
      } else if (typeof option === "object") {
        return option[this.label];
      } else {
        return option;
      }
    },
    getLabelValue(value) {
      if (typeof value === "object" && this.Api === true) {
        return value[this.label];
      } else if (typeof value === "object" && this.Api === false) {
        return value.value;
      } else {
        return value;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  width: 100%;
  margin: 8px;
  .select_title {
   margin-bottom: 10px;
    color: #22ABC5;
    font-size: 15px;
  }
  .select {
    color: #000000;
    background-color: white;
    padding: 12px;
    width: 94%;
    border-radius: 5px;
    border-color: #f2fdff;
    margin-top: 0px;
    margin-left: 0%;
    font-family: Metropolis;
    &:focus {
      outline: 0;
    }
    &::placeholder {
      color: #22a1b9;
      font-family: Metropolis;
    }
    .option {
      font-size: 13px;
      font-family: Metropolis;
    }
  }
  .selectBlue {
    color: white;
    background: #22ABC5;
    border-color: #22ABC5;
    padding: 10px;
    width: 70%;
    border-radius: 7px;
    margin-top: 0px;
    font-size: 20px;
    font-family: 'Seoge UI';
    margin-right: 10px;
    &:focus {
      outline: 0;
    }
    .option {
      padding:5px;
      font-size: 13px;
      color : white;
      background: #22ABC5;
      border : 1px solid #22ABC5;
      font-family: Metropolis;
    }
  }
}
.masque {
  display: none;
}
</style>
